import http from '../utils/http-client.util';
import * as url from '../comman/url';

export const SAAS_ACCOUNT_PLATFORMS = {
  TRACKING: 'tracking',
}

export const getSaasAccountByDomain = (domain, platform = SAAS_ACCOUNT_PLATFORMS.TRACKING) =>
  http.get(
    `${url.GET_SAAS_ACCOUNT_BY_DOMAIN}/?domain=${encodeURIComponent(domain)}&platform=${encodeURIComponent(platform)}`
  )
